import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
        <Path
            stroke={designSystem.colors.neutral300}
            strokeWidth={1.25}
            d="M5.6 5.6h1.6c1.509 0 2.263 0 2.731.469.469.469.469 1.223.469 2.731v1.6M5.6 5.6c0-1.508 0-2.262.469-2.731C6.537 2.4 7.292 2.4 8.8 2.4h1.6c1.508 0 2.263 0 2.731.469.469.469.469 1.223.469 2.731v1.6c0 1.509 0 2.263-.469 2.732-.468.468-1.223.468-2.731.468M5.6 5.6c-1.508 0-2.263 0-2.731.469C2.4 6.538 2.4 7.292 2.4 8.8v1.6c0 1.509 0 2.263.469 2.732.468.468 1.223.468 2.731.468h1.6c1.509 0 2.263 0 2.731-.468.469-.469.469-1.223.469-2.732"
        />
    </Svg>
);
export default SvgComponent;
